import React from 'react';

const ACCENT_STYLES = {
  blue:    { bg: 'bg-blue-50 dark:bg-blue-500/10',   text: 'text-blue-600 dark:text-blue-400',     hoverBg: 'group-hover:bg-blue-100 dark:group-hover:bg-blue-500/20' },
  emerald: { bg: 'bg-emerald-50 dark:bg-emerald-500/10', text: 'text-emerald-600 dark:text-emerald-400', hoverBg: 'group-hover:bg-emerald-100 dark:group-hover:bg-emerald-500/20' },
  amber:   { bg: 'bg-amber-50 dark:bg-amber-500/10', text: 'text-amber-600 dark:text-amber-400',   hoverBg: 'group-hover:bg-amber-100 dark:group-hover:bg-amber-500/20' },
  indigo:  { bg: 'bg-indigo-50 dark:bg-indigo-500/10', text: 'text-indigo-600 dark:text-indigo-400', hoverBg: 'group-hover:bg-indigo-100 dark:group-hover:bg-indigo-500/20' },
};

export function MetricCard({ icon, value, label, footer, accent = 'indigo' }) {
  const a = ACCENT_STYLES[accent] || ACCENT_STYLES.indigo;
  const accentClass = `ud-accent-${accent}`;

  return (
    <div
      className={`
        premium-stat-card ${accentClass} group relative flex flex-col overflow-hidden rounded-2xl border border-gray-200/80 bg-white/90 p-5 shadow-sm backdrop-blur-sm
        transition-all duration-300 ease-[cubic-bezier(0.22,1,0.36,1)]
        hover:-translate-y-1 hover:border-indigo-200/60 hover:shadow-lg
        dark:border-slate-700/60 dark:bg-slate-800/90 dark:shadow-md dark:shadow-slate-900/20
        dark:hover:border-indigo-500/30 dark:hover:shadow-xl dark:hover:shadow-indigo-500/5
      `}
    >
      <div className="mb-3 flex items-center justify-between">
        <div className="text-[11px] font-bold uppercase tracking-wider text-gray-500 dark:text-slate-400">
          {label}
        </div>
        <div
          className={`
            premium-stat-icon flex h-10 w-10 items-center justify-center rounded-xl
            ${a.bg} ${a.text}
            transition-all duration-200 ease-in-out group-hover:scale-110
            ${a.hoverBg}
          `}
        >
          {icon}
        </div>
      </div>
      <div className="user-dash-stat-num text-3xl font-extrabold tracking-tight text-gray-900 dark:text-slate-100">
        {value}
      </div>
      {footer != null && (
        <span className="premium-stat-trend mt-2 block text-[11px] font-medium text-gray-400 dark:text-slate-500">
          {footer}
        </span>
      )}
    </div>
  );
}

export default MetricCard;
